import { TextField, RadioGroup, FormControlLabel, Radio, FormLabel, FormControl, Box } from '@mui/material';
import MoneyIcon from '@mui/icons-material/Money';
import theme from './Theme';
import { PlaceFormData } from '@/hooks/usePlaceForm';

interface FeeFieldsProps {
  formData: PlaceFormData;
  onChange: (name: string, value: any) => void;
}

export const FeeFields = ({ formData, onChange }: FeeFieldsProps) => {
  return (
    <>
      <FormControl component="fieldset" fullWidth margin="normal" required>
        <FormLabel component="legend">
          <Box display="flex" alignItems="center" gap={1}>
            <MoneyIcon sx={{ color: theme.palette.accent.main }} />
            Fee Type
          </Box>
        </FormLabel>
        <RadioGroup
          row
          aria-label="fee_type"
          name="price_type"
          value={formData.fee.price_type}
          onChange={(e) => onChange('fee.price_type', e.target.value)}
        >
          <FormControlLabel value="one_time" control={<Radio />} label="One Time" />
          <FormControlLabel value="hourly" control={<Radio />} label="Hourly" />
        </RadioGroup>
      </FormControl>
      <FormControl component="fieldset" fullWidth margin="normal" required>
        <FormLabel component="legend">
          <Box display="flex" alignItems="center" gap={1}>
            <MoneyIcon sx={{ color: theme.palette.accent.main }} />
            Fee
          </Box>
        </FormLabel>
        <RadioGroup
          row
          aria-label="fee"
          name="price"
          value={formData.fee.price}
          onChange={(e) => onChange('fee.price', e.target.value)}
        >
          <FormControlLabel value="Free" control={<Radio />} label="Free" />
          <FormControlLabel value="1-5 BGN" control={<Radio />} label="1-5 BGN" />
          <FormControlLabel value="5-10 BGN" control={<Radio />} label="5-10 BGN" />
          <FormControlLabel value="10-20 BGN" control={<Radio />} label="10-20 BGN" />
          <FormControlLabel value="20+ BGN" control={<Radio />} label="20+ BGN" />
        </RadioGroup>
      </FormControl>
    </>
  );
};
